//src/components/MachineList.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Button, IconButton } from '@mui/material';
import { Add, Edit } from '@mui/icons-material';
import AddMachineList from './AddMachineList';
import EditMachineList from './EditMachineList';
import env from "react-dotenv";
import { format } from 'date-fns';

const formatDate = (date) => {
    if (!date) return '';  // Handle null/undefined cases
    return format(new Date(date), 'MM/dd/yyyy');  // Format to 'MM/dd/yyyy'
  };

const MachineList = () => {
  const [machines, setMachines] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedMachine, setselectedMachine] = useState(null);

  const fetchMachines = () => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/machinelist`)
      .then((response) => setMachines(response.data))
      .catch((error) => console.error('Error fetching data:', error));
  };

  useEffect(() => {
    fetchMachines();
  }, []);

  const handleOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
  };

  const handleOpenEdit = (report) => {
    setselectedMachine(report);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setselectedMachine(null);
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 100 },
    { field: 'MachineNo', headerName: 'Machine ID', width: 150 },
    { field: 'MachineName', headerName: 'Machine Name', width: 150 },
    { field: 'startDate', headerName: 'start Date', width: 200 },
    { field: 'endDate', headerName: 'End Date', width: 200 },
    // {
    //     field: 'startDate',
    //     headerName: 'Start Date',
    //     width: 150,
    //     valueFormatter: ({ value }) => formatDate(value), // Use the date formatter
    //   },
    //   {
    //     field: 'endDate',
    //     headerName: 'End Date',
    //     width: 150,
    //     valueFormatter: ({ value }) => formatDate(value), // Use the date formatter
    //   },

    { field: 'productId', headerName: 'Product ID', width: 100 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <IconButton color="primary" onClick={() => handleOpenEdit(params.row)}>
          <Edit />
        </IconButton>
      ),
    },
  ];

  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");

  return (
    <Box style={{ height: 500, marginLeft: "0px", marginRight: "10px" }}>
      <h4>Machine List</h4>

      <Button
        variant="contained"
        color="primary"
        // startIcon={<Add />}
        onClick={handleOpenAdd}
        sx={{
          // marginLeft: "1090px",
          marginTop: "5px",
          marginBottom: "10px",
          backgroundColor: '#00308F',
          color: '#ffffff',
          padding: '3px 5px',
          '&:hover': {
            backgroundColor: '#00207E',
          },
        }}
      >
        Add New
      </Button>

      <Box
         sx={{
          height: 500,
          overflowY: 'auto',
        }}
      >
        <DataGrid
          rows={machines}
          columns={columns}
          getRowId={(row) => row.id}
          pageSizeOptions={[10, 25, 50]}
          checkboxSelection
          disableRowSelectionOnClick
          slots={{ toolbar: GridToolbar }}
          sx={{
            boxShadow: 1,
            border: 1,
            borderColor: 'primary.light',
            typography: 'subtitle2',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            '.MuiDataGrid-columnHeaderTitle': {
              font: 'light important',
              overflow: 'visible !important'
            },
            '--DataGrid-overlayHeight': '300px'
          }}
        />
      </Box>

      <AddMachineList open={openAdd} handleClose={handleCloseAdd} fetchMachines={fetchMachines} />
      {selectedMachine && (
        <EditMachineList open={openEdit} handleClose={handleCloseEdit} fetchMachines={fetchMachines} report={selectedMachine} />
      )}

    </Box>
  );
};

export default MachineList;
